/**
 * Уведомление об исходе действия над инструментом: копирование тикера §9 и
 * отправка в терминал (§10 1.36). Модуль без зависимостей — его читают и экран,
 * и детальная панель, а цикла импортов между ними быть не должно.
 *
 * `seq` отличает два одинаковых сообщения подряд: без него повторное
 * действие не меняло бы состояние вовсе. `densityId` — плотность, по которой
 * действовали: панель чужой плотности чужое уведомление не показывает.
 */
export interface ActionNotice {
  outcome: "copied" | "failed";
  text: string;
  seq: number;
  densityId: string;
}

/** Следующее уведомление: номер растёт на каждое. */
export function nextActionNotice(
  previous: ActionNotice | null,
  outcome: ActionNotice["outcome"],
  text: string,
  densityId: string,
): ActionNotice {
  return { outcome, text, seq: (previous?.seq ?? 0) + 1, densityId };
}

/** Уведомление для панели открытой плотности: только своё, иначе `null`. */
export function noticeForDensity(
  notice: ActionNotice | null,
  densityId: string,
): ActionNotice | null {
  return notice !== null && notice.densityId === densityId ? notice : null;
}
